import { render, staticRenderFns } from "./ModalCustom.vue?vue&type=template&id=d98b42e8&scoped=true&"
import script from "./ModalCustom.vue?vue&type=script&lang=js&"
export * from "./ModalCustom.vue?vue&type=script&lang=js&"
import style0 from "./ModalCustom.vue?vue&type=style&index=0&id=d98b42e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98b42e8",
  null
  
)

export default component.exports